(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var _ = require('lodash')

module.exports = function () {

  var fieldsToCompare =
      { artist: '_artist'
      , promoter: '_promoter'
      , dealType: 'dealType'
      , percentage: 'percentage'
      , overallFee: 'overallFee'
      , overallFeeNotes: 'overallFeeNotes'
      , crossCollateralised: 'crossCollateralised'
      , tax: 'tax'
      , taxNotes: 'taxNotes'
      , productionNotes: 'productionNotes'
      , travelRequirements: 'travelRequirements'
      , hotelRequirements: 'hotelRequirements'
      , groundTransport: 'groundTransport'
      , visaRequirements: 'visaRequirements'
      , incidentals: 'incidentals'
      , passes: 'passes'
      , additionalProvisions: 'additionalProvisions'
      , confirmedDate: 'confirmedDate'
      , status: 'status'
      , generalProvisions: 'generalProvisions'
      }
    , listsToCompare =
      [ 'shows'
      , 'paymentSchedule'
      ]
    , excludeFieldsForLists =
      { shows: [ '_keywords' ]
      }

  function compareLists (list1, list2, fieldsToExclude, cb) {
    if (!fieldsToExclude) fieldsToExclude = [ ]

    if (list1.length !== list2.length) {
      cb(list1, list2)
    } else {
      var list1Difference = [ ]
        , list2Difference = [ ]

      list1.forEach(function (entity, index) {
        var leftEntity = entity
          , rightEntity = list2[index]
          , leftEntityCleared = leftEntity
          , rightEntityCleared = rightEntity

        fieldsToExclude.forEach(function (field) {
          delete leftEntityCleared[field]
          delete rightEntityCleared[field]
        })

        if (JSON.stringify(leftEntityCleared) !== JSON.stringify(rightEntityCleared)) {
          list1Difference.push(leftEntity)
          list2Difference.push(rightEntity)
        }
      })

      cb(list1Difference, list2Difference)
    }
  }

  function areFieldsSame (field1, field2) {
    if (typeof field1 === 'object' && typeof field2 === 'object') {
      return JSON.stringify(field1) === JSON.stringify(field2)
    }

    return field1 === field2
  }

  function createDiffObjects (r1, r2, cb) {
    var revision1 = r1
      , revision2 = r2
      , revision1Difference = { }
      , revision2Difference = { }

    listsToCompare.forEach(function (list) {
      compareLists(revision1[list], revision2[list], excludeFieldsForLists[list], function (d1, d2) {
        if (d1.length + d2.length > 0) {
          revision1Difference[list] = d1
          revision2Difference[list] = d2
        }
      })
    })

    _.forEach(fieldsToCompare, function (embellishedField, field) {

      if (!areFieldsSame(revision1[field], revision2[field])) {
        revision1Difference[embellishedField] = revision1[embellishedField]
        revision2Difference[embellishedField] = revision2[embellishedField]
      }
    })

    cb(revision1Difference, revision2Difference)
  }

  function compare (revision1, revision2, callback) {
    createDiffObjects(revision1, revision2, function (diff1, diff2) {
      var fieldsChanged = _.uniq(Object.keys(diff1).concat(Object.keys(diff2)))

      return callback(null, fieldsChanged)
    })
  }

  return (
    { compare: compare
    , createDiffObjects: createDiffObjects
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/api/contract-revision/lib/revision-comparator.js","/components/api/contract-revision/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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